import { render, staticRenderFns } from "./CustomerByEmail.vue?vue&type=template&id=15572939"
import script from "./CustomerByEmail.vue?vue&type=script&lang=js"
export * from "./CustomerByEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports